var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.672 22.9473L25.193 27.1686C25.3266 28.2774 24.1377 29.0522 23.1892 28.4778L17.5918 25.1514C16.9773 25.1514 16.3762 25.1114 15.7884 25.0312C16.7769 23.869 17.3647 22.3995 17.3647 20.8098C17.3647 17.0159 14.0784 13.9434 10.0173 13.9434C8.46768 13.9434 7.03829 14.3842 5.84935 15.159C5.80927 14.825 5.7959 14.491 5.7959 14.1437C5.7959 8.06541 11.0727 3.13599 17.5918 3.13599C24.1109 3.13599 29.3877 8.06541 29.3877 14.1437C29.3877 17.7506 27.5308 20.9434 24.672 22.9473Z",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3667 20.8098C17.3667 22.3995 16.7789 23.869 15.7903 25.0312C14.4678 26.6343 12.3704 27.6629 10.0193 27.6629L6.5326 29.7335C5.9448 30.0942 5.1967 29.5999 5.27686 28.9186L5.61083 26.287C3.82074 25.0446 2.67188 23.0541 2.67188 20.8098C2.67188 18.4586 3.92762 16.388 5.8513 15.159C7.04024 14.3842 8.46964 13.9434 10.0193 13.9434C14.0804 13.9434 17.3667 17.0158 17.3667 20.8098Z",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.7cf369e4.svg";
export { ForwardRef as ReactComponent };